import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=0144c315&scoped=true&"
import script from "./sort.vue?vue&type=script&lang=js&"
export * from "./sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0144c315",
  null
  
)

export default component.exports